<template>
	<div>
		<ButtonDropdownIconInputField :color.sync="_iconColor" :icon.sync="_iconName" />
		<ButtonDropdownInputTextField
			class="pt-2"
			v-model="_tooltipText"
			title="Tooltip"
			description="[Optional] Appears when hovering over the button dropdown"
		/>
		<div v-if="!advancedFeatures">
			<h5 class="message">
				<span
					class="text-underline"
					role="button"
					@click="advancedFeatures = true"
					@keydown.enter.space="advancedFeatures = true"
					tabindex="0"
					>Additional options</span
				>
			</h5>
		</div>
		<template v-else>
			<!-- <ButtonDropdownInputTextField
					v-model="dropdownText"
					title="Alternate dropdown label"
					description="Label when the dropdown is inside another dropdown"
				/> -->
			<ButtonDropdownInputTextField
				v-model="_mainScreenText"
				title="Main screen label"
				description="Label when the button is added to the app's main screen"
			/>
			<div>
				<h5 class="message">
					<span
						class="text-underline"
						role="button"
						@click="advancedFeatures = false"
						@keydown.enter.space="advancedFeatures = false"
						tabindex="0"
						>Hide</span
					>
				</h5>
			</div>
		</template>
		<ButtonDropdownIconPreview
			title="Preview"
			:icon-color="iconColor"
			:icon-name="iconName"
			:tooltip-text="tooltipText"
			:main-screen-text="mainScreenText"
		/>
	</div>
</template>

<script>
import ButtonDropdownInputTextField from './ButtonDropdownInputTextField.vue';
import ButtonDropdownIconInputField from './ButtonDropdownIconInputField.vue';
import ButtonDropdownIconPreview from './ButtonDropdownIconPreview.vue';

export default {
	name: 'ButtonDropdownInputForm',
	props: {
		iconName: { type: String },
		iconColor: { type: String },
		tooltipText: { type: String },
		alternateDropdownLabel: { type: String },
		mainScreenText: { type: String },
	},
	computed: {
		_iconName: {
			get() {
				return this.iconName;
			},
			set(value) {
				this.$emit('update:iconName', value);
			},
		},
		_iconColor: {
			get() {
				return this.iconColor;
			},
			set(value) {
				this.$emit('update:iconColor', value);
			},
		},
		_tooltipText: {
			get() {
				return this.tooltipText;
			},
			set(value) {
				this.$emit('update:tooltipText', value);
			},
		},
		_mainScreenText: {
			get() {
				return this.mainScreenText;
			},
			set(value) {
				this.mainScreenTextLocal = value;
				this.$emit('update:mainScreenText', value);
			},
		},
	},
	components: { ButtonDropdownInputTextField, ButtonDropdownIconInputField, ButtonDropdownIconPreview },
	data() {
		return { advancedFeatures: !!this.mainScreenText, mainScreenTextLocal: this.mainScreenText };
	},
	watch: {
		advancedFeatures(val) {
			this.$emit('update:mainScreenText', val ? this.mainScreenTextLocal : '');
		},
	},
};
</script>

<style lang="scss" scoped></style>
